import styled from "@emotion/styled";

interface ButtonProps {
  variant?: "primary" | "secondary" | "tertiary" | "outline";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
}

export const Button = styled.button<ButtonProps>`
  border: none;
  border-radius: ${(props) => props.theme.borderRadius.md};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-family: inherit;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(props) => props.theme.shadows.md};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  background: ${(props) => {
    switch (props.variant) {
      case "primary":
        return props.theme.colors.primary;
      case "secondary":
        return props.theme.colors.secondary;
      case "tertiary":
        return props.theme.colors.tertiary;
      default:
        return "transparent";
    }
  }};

  color: ${(props) => {
    switch (props.variant) {
      case "primary":
      case "secondary":
        return "white";
      case "tertiary":
        return "white";
      default:
        return props.theme.colors.text;
    }
  }};

  border: 2px solid
    ${(props) => {
      switch (props.variant) {
        case "primary":
          return props.theme.colors.primary;
        case "secondary":
          return props.theme.colors.secondary;
        default:
          return props.theme.colors.text;
      }
    }};

  padding: ${(props) => {
    switch (props.size) {
      case "small":
        return `${props.theme.spacing.xs} ${props.theme.spacing.sm}`;
      case "large":
        return `${props.theme.spacing.md} ${props.theme.spacing.lg}`;
      default:
        return `${props.theme.spacing.sm} ${props.theme.spacing.md}`;
    }
  }};

  font-size: ${(props) => {
    switch (props.size) {
      case "small":
        return "0.875rem";
      case "large":
        return "1.125rem";
      default:
        return "1rem";
    }
  }};

  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
`;
